export default __webpack_public_path__ + "static/logo-3e706605a4f33d433853c15bf0426d8d.svg";